import { createFileRoute, redirect } from "@tanstack/react-router";

import { isDocsEnabledForUser } from "@/features/Docs/flag";
import { resolveCurrentSiteId } from "@/hooks/useLastSelectedSite";

// /docs without a site: pick one the way the home route does.
export const Route = createFileRoute("/_auth/docs/")({
  beforeLoad: ({ context }) => {
    const siteId = resolveCurrentSiteId(context.auth?.sites ?? []);
    if (!siteId || !isDocsEnabledForUser(context.auth?.user)) {
      throw redirect({ to: "/" });
    }
    throw redirect({ to: "/docs/$siteId", params: { siteId } });
  },
});
